export default __webpack_public_path__ + "0d194475c4085eb12a7260325c0990aa.png";